module.exports = __webpack_public_path__ + "img/cross.696cbfd3.svg";